<p id=deviz-desc>
  Наш девиз: "Вперёд и вверх! Вперёд и вверх! Вперёд и вверх к победе!"<br>

  Наши законы:
  <mat-list>
    <mat-list-item>Человек человеку друг!</mat-list-item>
    <mat-list-item>Никогда не оставляй друга в беде</mat-list-item>
    <mat-list-item>Работай сам, помогай товарищу</mat-list-item>
    <mat-list-item>Не жди, когда работа найдёт тебя - ищи её сам</mat-list-item>
    <mat-list-item>Делай своё дело так, чтобы трое его не переделывали</mat-list-item>
    <mat-list-item>Знаешь сам - расскажи другому, умеешь сам - научи другого</mat-list-item>
    <mat-list-item>Не бойся казаться смешным</mat-list-item>
    <mat-list-item>Лучший подарок маме - это Я!</mat-list-item>
  </mat-list>
</p>
